import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import React, { useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../App.css";
import axios from "axios";
import { useEffect } from "react";
import "./calendar.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import authHeader from "../services/auth-header";

const API_URL = "https://db.irli.org:8080/api/";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

function CalendarComp() {
  const events = [];
  let history = useHistory();

  const [newEvent, setNewEvent] = useState({ title: "", start: "", end: "" });
  const [allEvents, setAllEvents] = useState(events);
  const [selectedEvent, setSelectedEvent] = useState(undefined);
  const [modalState, setModalState] = useState(false);

  const handleSelectedEvent = (event) => {
    //    setSelectedEvent(event);1
    //    //setModalState(true);1
    console.log(event);
    history.push("/cases/view/" + event.id);
  };

  const Modal = () => {
    return (
      <div className={`modal-${modalState === true ? "show" : "hide"}`}>
        {selectedEvent.title}
      </div>
    );
  };

  useEffect(() => {
    axios
      .get(API_URL + "cases/events", { headers: authHeader() })
      .then((res) => {
        console.log(res.data);
        setAllEvents(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="App">
      <h1>Calendar</h1>
      <Calendar
        localizer={localizer}
        events={allEvents}
        startAccessor="start"
        endAccessor="end"
        views={["month", "agenda"]}
        style={{ height: 750, margin: "50px", color: "black" }}
        onSelectEvent={handleSelectedEvent}
        eventPropGetter={(event, start, end, isSelected) => {
          let newStyle = {
            backgroundColor: "lightblue",
            color: "black",
            fontSize: 12,
            borderRadius: "4px",
            border: "none",
          };

          if (event.isMine) {
            newStyle.backgroundColor = "lightgreen";
          }

          return {
            className: "",
            style: newStyle,
          };
        }}
      />
    </div>
  );
}

export default CalendarComp;